module.exports = __webpack_public_path__ + "static/img/xray_2.f1a1e2cb.jpg";